// Action Auth 
export const USER_LOG_IN = 'USER_LOG_IN'
export const USER_LOG_IN_SUCCESS = 'USER_LOG_IN_SUCCESS'
export const USER_LOG_IN_FAILURE = 'USER_LOG_IN_FAILURE'
export const USER_LOG_IN_GOOGLE = 'USER_LOG_IN_GOOGLE'
export const USER_LOG_IN_GOOGLE_SUCCESS = 'USER_LOG_IN__GOOGLE_SUCCESS'
export const USER_LOG_IN_GOOGLE_FAILURE = 'USER_LOG_IN_GOOGLE_FAILURE'
export const USER_SIGNUP = 'USER_SIGNUP'
export const USER_SIGNUP_SUCCESS = 'USER_SIGNUP_SUCCESS'
export const USER_SIGNUP_FAILURE = 'USER_SIGNUP_FAILURE'
export const USER_LOG_OUT = 'USER_LOG_OUT'
export const USER_LOG_OUT_SUCCESS = 'USER_LOG_OUT_SUCCESS'
export const USER_LOG_OUT_FAILURE = 'USER_LOG_OUT_FAILURE'
export const USER_VALIDATE_TOKEN = 'USER_VALIDATE_TOKEN'
export const USER_VALIDATE_TOKEN_SUCCESS = 'USER_VALIDATE_TOKEN_SUCCESS'
export const USER_VALIDATE_TOKEN_FAILURE = 'USER_VALIDATE_TOKEN_FAILURE'

// Action User 
export const GET_PROFILE = 'GET_PROFILE';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAILURE = 'GET_PROFILE_FAILURE';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';


// Action Fitur Admin
export const CREATE_FIELD = 'CREATE_FIELD'
export const CREATE_FIELD_SUCCESS = 'CREATE_FIELD_SUCCESS'
export const CREATE_FIELD_FAILURE = 'CREATE_FIELD_FAILURE'
export const UPDATE_FIELD = 'UPDATE_FIELD'
export const UPDATE_FIELD_SUCCESS = 'UPDATE_FIELD_SUCCESS'
export const UPDATE_FIELD_FAILURE = 'UPDATE_FIELD_FAILURE'
export const DELETE_FIELD = 'DELETE_FIELD'
export const DELETE_FIELD_SUCCESS = 'DELETE_FIELD_SUCCESS'
export const DELETE_FIELD_FAILURE = 'DELETE_FIELD_FAILURE'

// Action Booking
export const BOOKED_TIMESLOT = 'BOOKED_TIMESLOT'
export const BOOKED_TIMESLOT_SUCCESS = 'BOOKED_TIMESLOT_SUCCESS'
export const BOOKED_TIMESLOT_FAILURE = 'BOOKED_TIMESLOT_FAILURE'
export const GET_BOOKED_TIMESLOT = 'GET_BOOKED_TIMESLOT'
export const GET_BOOKED_TIMESLOT_SUCCESS = 'GET_BOOKED_TIMESLOT_SUCCESS'
export const GET_BOOKED_TIMESLOT_FAILURE = 'GET_BOOKED_TIMESLOT_FAILURE'
export const BOOKED_PERSON = 'BOOKED_PERSON'
export const BOOKED_PERSON_SUCCESS = 'BOOKED_PERSON_SUCCESS'
export const BOOKED_PERSON_FAILURE = 'BOOKED_PERSON_FAILURE'
export const BOOKED_TEAM = 'BOOKED_TEAM'
export const BOOKED_TEAM_SUCCESS = 'BOOKED_TEAM_SUCCESS'
export const BOOKED_TEAM_FAILURE = 'BOOKED_TEAM_FAILURE'
export const BOOKED_FIELD = 'BOOKED_FIELD'
export const BOOKED_FIELD_SUCCESS = 'BOOKED_FIELD_SUCCESS'
export const BOOKED_FIELD_FAILURE = 'BOOKED_FIELD_FAILURE'

// NEXT FITUR
export const USER_CONFIRM = 'USER_CONFIRM'
export const USER_CONFIRM_SUCCESS = 'USER_CONFIRM_SUCCESS'
export const USER_CONFIRM_FAILURE = 'USER_CONFIRM_FAILURE'
export const USER_RESET_PASSWORD_REQUEST = 'USER_RESET_PASSWORD_REQUEST'
export const USER_RESET_PASSWORD_REQUEST_SUCCESS = 'USER_RESET_PASSWORD_REQUEST_SUCCESS'
export const USER_RESET_PASSWORD_REQUEST_FAILURE = 'USER_RESET_PASSWORD_REQUEST_FAILURE'
export const USER_RESET_PASSWORD = 'USER_RESET_PASSWORD'
export const USER_RESET_PASSWORD_SUCCESS = 'USER_RESET_PASSWORD_SUCCESS'
export const USER_RESET_PASSWORD_FAILURE = 'USER_RESET_PASSWORD_FAILURE'



